<template>
    <el-row class="warp">
        <!--编辑期刊基本信息对话框界面 begin-->
        <el-dialog 
            title="编辑期刊" 
            :visible.sync="editFormVisible" 
            :close-on-click-modal="false">
            <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">
                <!-- 创建form -->
                <el-form-item label="请填写期刊名称：" prop="journalName">
                    <el-input v-model="editForm.journalName" placeholder="在此输入期刊名称"></el-input>
                </el-form-item>
                <el-form-item label="请填写期刊ISSN:" prop="issn">
                    <el-input v-model="editForm.issn" placeholder="在此输入期刊issn"></el-input>
                </el-form-item>
                 <el-form-item label="请选择希望对接的方案:" prop="refList">
                    <el-cascader
                        placeholder="请选择希望对接的方案"
                        ref="cascader"
                        v-model="selectedIds"
                        :options="refOption"
                        :props="defaultParams"
                        @change="handleCascaderCheckChange">
                    </el-cascader> <el-button type="primary" icon="el-icon-plus" :disabled="addBtnChangeEnable" @click.prevent="addRef()">添加</el-button>
                    <el-table :data="checkedData">
                        <el-table-column property="pubName" label="出版类型"></el-table-column>
                        <el-table-column property="processName" label="转换方法"></el-table-column>
                        <el-table-column property="ftpName" label="FTP"></el-table-column>
                        <!-- 操作按钮 -->
                        <el-table-column label="操作" width="240" align="center">
                            <template slot-scope="scope">
                            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="请选择结果发送邮箱:" prop="mailAddr">
                    <el-select v-model="editForm.mailId" filterable placeholder="请选择结果发送邮箱">
                        <el-option
                        v-for="item in editForm.mail"
                        :key="item.mailId"
                        :label="item.mailAddr"
                        :value="item.mailId"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择是否启用数据上传过期提醒功能：" prop="uploadDue">
                    <el-switch
                        v-model="uploadDue"
                        active-text="启用"
                        inactive-text="关闭">
                    </el-switch>
                </el-form-item>
                <el-form-item label="请选择期刊类型:" prop="issueType">
                    <el-radio v-model="radio" label="0">半月刊</el-radio>
                    <el-radio v-model="radio" label="1">月刊</el-radio>
                    <el-radio v-model="radio" label="2">双月刊</el-radio>
                    <el-radio v-model="radio" label="3">季刊</el-radio>
                </el-form-item>
                <el-form-item label="请选择期刊上传权限：" prop="uploadType">
                    <el-select v-model="uploadList" multiple placeholder="请选择自动转换类型">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                        ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="请选择是否启用审核功能：" prop="audit">
                    <el-switch
                        v-model="audit"
                        active-text="启用"
                        inactive-text="关闭">
                    </el-switch>
                </el-form-item>
                <el-form-item label="请选择是否启用校验卷期功能：" prop="checkVolumeIssue">
                    <el-switch
                        v-model="checkVolumeIssue"
                        active-text="启用"
                        inactive-text="关闭">
                    </el-switch>
                </el-form-item>
                <el-form-item label="请填写DOAJ-APIKEY:">
                    <el-input v-model="editForm.apiKey" placeholder="在此输入期刊DOAJ-APIKEY"></el-input>
                </el-form-item>
                <el-form-item label="请填写DOAJ-APIID:">
                    <el-input v-model="editForm.apiId" placeholder="在此输入期刊DOAJ-APIID"></el-input>
                </el-form-item>
            </el-form>

            <!-- 创建form -->
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click.native="editJournalSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
    </el-row>
</template>
<script>
    import API_JOURNAL from "../../../api/api_journal";
    import API_MAIL from "../../../api/api_mail";
    import API_UPLOADTYPE from "../../../api/api_uploadType";

    export default {
        name: "editJournalDialog",
        components: {},
        props: {
            journal: {
                type:Object,
                required: true
            },
        },
        data() {
            return{
                options: [],
                //上传的转换类型，0代表不转换，1代表仁和，2代表玛格
                uploadList: [],
                refOption:[],
                selectedOptions:{},
                defaultParams:{
                    label:'name',
                    value:'id',
                    children:'children',
                },
                selectedIds:[],

                //已选择的方案
                checkedData:[],

                radio:'1',

                //校验卷期功能开关
                checkVolumeIssue: true,

                //审核功能开关
                audit: false,

                //数据上传过期提醒开关
                uploadDue:false,

                addBtnChangeEnable:true,

                //编辑相关数据
                editFormVisible: false, //编辑界面是否显示
                editLoading: false, //编辑界面加载状态
                editFormRules: {
                    journalName: [
                        { required: true, message: "请输入期刊名称", trigger: "blur" }
                    ],
                    issn:[
                        { required: true, message: "请输入期刊issn", trigger: "blur" }
                    ],
                    mailId:[
                        { required: true, message: "请选择结果发送邮箱", trigger: "blur"}
                    ],
                },
                editForm: {
                    journalId:"",
                    journalName: "",
                    issn: "",
                    mail:[],
                    mailId:"",
                    apiKey:"",
                    apiId:"",
                },
            };
        },

        methods:{
            cleanData(){
                this.refOption=[];
                this.checkedData=[];
                this.$refs["editForm"].resetFields(); //清空数据
            },
            closeDialog() {
                this.editFormVisible = false;
                this.checkedData=[];
                this.$refs["editForm"].resetFields(); //清空数据
            },
            openDialog(journal){
                // journal = journal;
                this.editForm.journalId = journal.journalId;
                this.editForm.journalName = journal.journalName;
                this.editForm.issn = journal.issn;
                this.editForm.mailId = journal.mailId;
                this.editForm.apiId = journal.apiId;
                this.editForm.apiKey = journal.apiKey;
                this.checkedData = journal.refList;
                this.radio = journal.issueType;
                this.uploadList = journal.uploadTypeList;
                this.audit = journal.audit;
                this.checkVolumeIssue = journal.checkVolumeIssue;
                this.uploadDue = journal.uploadDue;
                this.findUploadTypeOption();
                this.findMail();
                this.findRefTree();
                setTimeout(() => {     
                        this.checkedData.forEach(item => {
                        console.log("......item:", item);
                        this.setDisable(item,this.refOption);
                    })  
                }, 500);
                this.editFormVisible = true;    
            },

            findUploadTypeOption(){
                let that = this;
                //发送http请求
                API_UPLOADTYPE.getUploadTypeList()
                    .then(res => {
                    if (res) {
                        //赋值
                        that.options = res.uploadTypeList;
                        console.log("......findUploadTypeOption res:" + JSON.stringify(that.options));
                    }
                    })
                    .catch(e => {
                    this.$message({
                        showClose: true,
                        type: "error",
                        message: "请求出现异常"+e,
                        duration: 2000
                    });
                });
            },

            findRefTree() {
                let that = this;
                console.log("......findRefTree");
                //发送http请求
                API_JOURNAL.getRefTree()
                    .then(res => {
                    if (res) {
                        //赋值
                        that.refOption = res.pubList;
                        console.log("......findRefTree res:" + JSON.stringify(that.refOption));
                    }
                    })
                    .catch(e => {
                    this.$message({
                        showClose: true,
                        type: "error",
                        message: "请求出现异常",
                        duration: 2000
                    });
                });
            },

            findMail(){
                let that = this;
                console.log("......findMail");
                //发送http请求
                API_MAIL.getAllMail()
                    .then(res => {
                    if (res) {
                        //赋值
                        that.editForm.mail = res.mailConfigs;
                        console.log("......findMail res:" + JSON.stringify(that.editForm.mail));
                    }
                    })
                    .catch(e => {
                    this.$message({
                        showClose: true,
                        type: "error",
                        message: "请求出现异常",
                        duration: 2000
                    });
                });
            },
        

            handleCascaderCheckChange(value){
                this.selectedOptions = {};
                console.log("......value:", value);
                console.log("......label:", this.$refs["cascader"].getCheckedNodes()[0].label);
                console.log("......nodes:", this.$refs["cascader"].getCheckedNodes());
                var arr = value;
                arr.map(item => {
                    this.buildCheckedRefList(item);
                })
                console.log("......selectedOptions:", this.selectedOptions);

                //按钮变为可选
                this.addBtnChangeEnable = false;
            },

            buildCheckedRefList(value){
                let node = this.$refs["cascader"].panel.getNodeByValue(value);
                console.log("......node:", node);
                if(node.level === 3){
                    this.selectedOptions.ftpName = node.label;
                    this.selectedOptions.ftpId = node.value;
                }
                else if(node.level ===2){
                    this.selectedOptions.processName = node.label;
                    this.selectedOptions.processId = node.value;
                }
                else{
                    this.selectedOptions.pubName = node.label;
                    this.selectedOptions.pubId = node.value;
                }

            },

            addRef(){
                this.checkedData.push(this.selectedOptions);
                console.log("......checkedData:", this.checkedData);
                //已选择的设置为不可选
                this.setDisable(this.selectedOptions,this.refOption);

                //清空已选项
                this.selectedIds=[];

                //按钮变为不可选
                this.addBtnChangeEnable = true;
            },

            setDisable(selected, refOption){
                refOption.forEach(pub =>{
                    if(pub.id === selected.pubId){
                        //最高层出版类型匹配上,找中间层
                        pub.children.forEach(process => {
                            if(process.id === selected.processId){
                                //中间层匹配，设置不可选
                                process.disabled = true;
                            }
                        })
                    }
                })
            },

            setEnable(selected, refOption){
                refOption.forEach(pub =>{
                    if(pub.id === selected.pubId){
                        //最高层出版类型匹配上,找中间层
                        pub.children.forEach(process => {
                            if(process.id === selected.processId){
                                //中间层匹配，设置不可选
                                process.disabled = false;
                            }
                        })
                    }
                })
            },

            //删除操作
            handleDelete: function(index, row) {
                console.log("......handleDelete,index:", index);
                console.log("......handleDelete,row:",row);
                //轮询开放可选项
                this.setEnable(row, this.refOption);
                //数组中删除当前行
                this.checkedData.splice(index,1);
                console.log("......handleDelete,checkData:",this.checkedData);
                // 重置激活路径，级联下拉框恢复默认，收起展开节点路径面板
                this.$refs.cascader.panel.activePath = [];
                this.$refs.cascader.panel.syncActivePath();
            },
            
            //编辑提交
            editJournalSubmit: function() {
                let that = this;
                if (that.formLoading) return;

                that.$refs.editForm.validate(valid => {
                    if (valid) {
                    let params = {
                        journalId: that.editForm.journalId,
                        journalName: that.editForm.journalName,
                        issn: that.editForm.issn,
                        mailId: that.editForm.mailId,
                        refList: that.checkedData,
                        issueType: that.radio,
                        uploadTypeList: that.uploadList,
                        audit: that.audit,
                        checkVolumeIssue:that.checkVolumeIssue,
                        uploadDue: that.uploadDue,
                        apiKey: that.editForm.apiKey,
                        apiId: that.editForm.apiId,
                    };

                    console.log(
                        ".........journal create by params:" + JSON.stringify(params)
                    );

                    //发送http请求
                    API_JOURNAL.updateJournal(params)
                        .then(res => {
                        if (0 === res.errorCode) {
                            that.$message({
                            type: "success",
                            message: "更新成功!"
                            });
                            //清空数据
                            that.$refs["editForm"].resetFields(); 
                            that.checkedData=[];
                            that.editFormVisible = false;
                            that.$emit('signStatusVerdict',true);
                        } else {
                            that.$message({
                            showClose: true,
                            message: res.errorInfo,
                            type: "error"
                            });
                        }
                        })
                        .catch(e => {
                        that.$message({
                            showClose: true,
                            type: "error",
                            message: "请求出现异常",
                            duration: 2000
                        });
                        });
                    } else {
                    that.$message({
                        showClose: true,
                        type: "error",
                        message: "请正确填写信息！",
                        duration: 2000
                    });
                    }
                });
            },
        },
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Journal/EditJournal.vue